import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a9ca1b50")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLines = _resolveComponent("GridLines")

  return (_openBlock(), _createBlock("div", {
    class: "viewport-background",
    style: _ctx.backgroundStyle
  }, [
    (_ctx.showGridLines)
      ? (_openBlock(), _createBlock(_component_GridLines, { key: 0 }))
      : _createCommentVNode("", true)
  ], 4))
})